<x-request-installer-assignment-form
  [requestIds]="[request.id]"
  [ownerId]="request.counterpartyOwnerId.id"
  [initialAssignment]="initialAssignment"
  (completedOutput)="closeUpdated()"
  (canceledOutput)="cancel()"
/>
